function stabilize(spgContainer) {
  const option = spgContainer.closest('.loop-widget-purchase-option');
  if (!option?.classList.contains('loop-widget-purchase-option-selected')) return;

  spgContainer.style.transition = 'none';
  spgContainer.classList.add('expanded');
  setTimeout(() => spgContainer.style.removeProperty('transition'), 500);
}

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node.matches('.loop-widget-container') || node.querySelector('.loop-widget-container')) continue;

      if (!node.closest('.loop-widget-container')) continue;

      if (node.matches('.loop-widget-spg-container')) {
        stabilize(node);
      } else {
        node.querySelectorAll('.loop-widget-spg-container').forEach(stabilize);
      }
    }
  }
}).observe(document.body, { childList: true, subtree: true });
